import { useEffect, useRef } from "react";
import { serviceAreas } from "@/mocks/serviceAreas";

export default function ServiceAreas() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".reveal");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 md:py-28 lg:py-32 bg-primary-700">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="reveal text-accent-400 text-xs font-semibold tracking-[0.25em] uppercase mb-4 block">
              Coverage Area
            </span>
            <h2 className="reveal font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-6">
              Serving All of <span className="text-accent-400">California</span>
            </h2>
            <p className="reveal text-background-50/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              Fast response times, 24/7 coverage across every major city and county in the state.
            </p>
          </div>

          <div className="reveal flex flex-wrap justify-center gap-3 md:gap-4">
            {serviceAreas.map((area, index) => (
              <span
                key={area}
                className="inline-flex items-center bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50/90 text-sm font-medium px-4 py-2 rounded-full transition-all duration-300 cursor-default"
                style={{
                  animationDelay: `${index * 50}ms`,
                }}
              >
                <i className="ri-map-pin-line mr-2 text-accent-400 text-xs" />
                {area}
              </span>
            ))}
          </div>

          <div className="reveal mt-12 text-center">
            <div className="inline-flex items-center gap-2 text-background-50/60 text-sm">
              <i className="ri-time-line text-accent-400" />
              <span>Response times averaging under 15 minutes in metro areas</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}